module.exports = __webpack_public_path__ + "img/icon-reporting-light.2e548800.svg";